"use client";
import React from "react";
import { motion } from "framer-motion";
import { FaKey, FaLock, FaEye } from "react-icons/fa";

const Secure = () => {
  return (
    <div className="bg-white text-dark ">
      {/* Header Section */}
      <section className="container py-5">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="fw-bold display-5 text-primary"
        >
          Secured Question Paper Transmission
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-3 fs-5 text-black"
        >
          Ensuring{" "}
          <span className="fw-semibold text-black">
            confidentiality, integrity, and timely delivery
          </span>{" "}
          of question papers through advanced encryption, monitoring, and secure
          access protocols.
        </motion.p>
      </section>

      {/* Preface / Description */}
      <section className="container pb-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="p-4  bg-opacity-10 border-start border-4 border-primary rounded shadow-sm"
          style={{ backgroundColor: "#0a1530" }}
        >
          <h3 className="h4 fw-semibold text-primary mb-3">
            Why Secure Transmission?
          </h3>
          <p className=" text-white">
            The delivery of question papers to exam centres is a{" "}
            <span className="fw-bold text-white">
              mission-critical pre-examination task
            </span>
            . Our Secure Question Paper Transmission module empowers
            institutions to transmit papers with absolute ease and confidence,
            eliminating risks of leaks or unauthorized access.
          </p>
        </motion.div>
      </section>

      {/* Security Features */}
      <section className="container pb-5">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="fw-bold h2 text-primary text-center mb-4"
        >
          Security Features
        </motion.h2>

        <div className="row g-4">
          {/* Access Control */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="col-md-4"
          >
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3 text-primary fs-5">
                  <FaKey className="me-2" />
                  <h5 className="fw-semibold mb-0">Access Control</h5>
                </div>
                <ul className="list-unstyled text-black">
                  <li>Firewall configured for authenticated users</li>
                  <li>Authentication for college systems</li>
                  <li>Login restricted to verified devices</li>
                </ul>
              </div>
            </div>
          </motion.div>

          {/* Encryption */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.6 }}
            viewport={{ once: true }}
            className="col-md-4"
          >
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3 text-primary fs-5">
                  <FaLock className="me-2" />
                  <h5 className="fw-semibold mb-0">Encryption & Protection</h5>
                </div>
                <ul className="list-unstyled text-black">
                  <li>128-bit AES encryption for question papers</li>
                  <li>Optional SSL layer for data security</li>
                  <li>Watermark & centre code on each paper</li>
                </ul>
              </div>
            </div>
          </motion.div>

          {/* Monitoring */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
            className="col-md-4"
          >
            <div className="card shadow-sm h-100 border-0 text-center">
              <div className="card-body">
                <div className="text-primary fs-2 mb-2">
                  <FaEye />
                </div>
                <h5 className="fw-semibold mb-2">Real-time Monitoring</h5>
                <p className="text-black">
                  Track download and access status at each exam centre with
                  real-time monitoring and detailed logs.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Closing Statement */}
      <section className="container pb-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="card shadow-sm border-0 p-4"
        >
          <p className="text-black">
            With robust encryption, strict access controls, and live monitoring,
            our Secure Transmission system ensures{" "}
            <span className="fw-semibold text-primary">
              exam confidentiality and trust
            </span>
            . It eliminates human error, enhances reliability, and protects the
            credibility of the examination process.
          </p>
        </motion.div>
      </section>
    </div>
  );
};

export default Secure;
